const locale = {
  dashboard: 'Cruscotto',
  home_dashboard: 'Accoglienza',
  dashboard_news: 'Notizie',
  dashboard_slides: 'Banner',
  dashboard_notifications: 'Notifiche',
  dashboard_account: 'Il mio account',
  dashboard_team: 'Il mio team',
  dashboard_mini_site: 'Mini-sito',
  dashboard_loyalty_campaign: 'Campagna fedeltà',
  product_order: 'Ordina prodotti',
  digital_pub: 'Pubblicità digitale',
  training: 'Formazione',
  dashboard_content_library: 'Libreria di contenuti',
  hairdressers_network: 'Rete di parrucchieri',
  hairdressers: 'Parrucchieri',
  hairdressers_list: 'Elenco dei parrucchieri',
  hairdresser_add: 'Aggiungi un parrucchiere',
  link_hairdresser_supervisor: 'Collegamento parrucchiere/supervisore',
  services: 'Servizi',
  services_list: 'Elenco dei servizi',
  services_add: 'Aggiungi un servizio',
  services_link: 'Associare un servizio',
  national_operations: 'Ope nazionale',
  national_operations_list: 'Elenco delle ope nazionali',
  national_operations_add: 'Aggiungere una ope nazionale',
  national_operations_participate: 'Associare una ope nazionale',
  prices: 'Prestazione e tariffe',
  jobs: 'Offerte di lavoro',
  jobs_list: 'Elenco delle offerte di lavoro',
  jobs_add: 'Aggiungi una offerta di lavoro',
  customer_relationship: 'Relazione con il cliente',
  contacts: 'Contatti',
  contacts_list: 'Elenco dei contatti',
  contacts_import: 'Importa contatti',
  origin_code_list: 'Elenco dei codici di origine',
  origin_code_add: 'Aggiungere un codice di origine',
  feedbacks: 'Recensioni dei clienti',
  feedbacks_list: 'Elenco delle recensioni',
  feedbacks_response_model: 'Modello di risposta',
  feedbacks_receiver: 'Destinari di recensioni',
  access: 'Accesso',
  collaborators: 'Elenco dei collaboratori',
  collaborators_add: 'Aggiungi un collaboratore',
  users_and_groups: 'Utenti e gruppi',
  users_list: 'Elenco utenti',
  users_add: 'Aggiungi un utente',
  groups_list: 'Elenco dei gruppi',
  groups_add: 'Aggiungi un gruppo',
  resources: 'Risorse',
  press: 'Spazio stampa',
  press_admin: 'Amministrazione della stampa',
  documentation: 'Documentazione',
  documentation_admin: 'Amministrazione della documentazione',
  intranet_doc: 'Spazio documentario',
  mass_administration: 'Gestione di massa',
  minisite: 'Minisito',
  minisiteList: 'Monitoraggio degli aggiornamenti',
  minisiteMessageList: 'Elenco dei saluti',
  minisiteTagList: 'elenco di meta tag',
  minisiteMassiveImport: 'Amministrazione di massa',
  access_to: 'accesso a',
  payment_x3: 'Pagamento in 3x',
  prices_list: 'Elenco dei servizi e tariffe',
  legals_list: 'Elenco delle note legali',
  legals_add: 'Aggiungi una nota legale',
  legals_participate: 'Associa una nota legale',
  mass_administration_price_list: 'Servizi e Tariffe',
  mass_administration_businessHours_list: 'Orari di apertura',
  mass_administration_message_list: 'Messaggi di Benvenuto',
  mass_administration_tag_list: 'Tag Meta',
  mass_administration_picture_list: 'Foto',
  terms_nav: 'Termini e condizioni',
  TOU: 'CGU',
  privacy_policy: 'Informativa sulla privacy',
  cookies_policy: 'Politica di gestione dei cookie',
  faq: 'Domande frequenti'
};

export default locale;
